// @flow

import setupConfig from './setup/config';
import setupRequest from './setup/request';
import setupI18n from './setup/i18n';
import setupDate from './setup/date';

export default () => {
    setupConfig();
    setupRequest();
    setupI18n();
    setupDate();
};
